import { ComplianceStatus } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { StatusChip } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import React from 'react';

import { ComplianceStatusTranslations } from '../../i18n';

export const ComplianceStatusChip: React.FunctionComponent<{
    status: ComplianceStatus;
    disabled?: boolean;
}> = ({ status, disabled = false }) => {
    const label = transEnum(status, ComplianceStatusTranslations);
    switch (status) {
        case ComplianceStatus.Compliant:
            return <StatusChip color="green" label={label} disabled={disabled} showEllipsis />;
        case ComplianceStatus.CompliantWithExemption:
            return <StatusChip color="green" label={label} disabled={disabled} showEllipsis />;
        case ComplianceStatus.NonCompliant:
            return <StatusChip color="red" label={label} disabled={disabled} showEllipsis />;
        case ComplianceStatus.NotRequired:
            return <StatusChip color="neutral" label={label} disabled={disabled} showEllipsis />;
        case ComplianceStatus.Unknown:
            return <StatusChip color="neutral" label={label} disabled={disabled} showEllipsis />;
        default:
            assertUnreachable(status);
    }
};
